import { api } from '../utils/apiClient';

export const journeyService = {
  async getAll(params) {
    return api.get('/journeys', params);
  },

  async getById(id) {
    return api.get('/journeys/' + id);
  },

  async create(journey) {
    return api.post('/journeys', journey);
  },

  async update(id, patch) {
    return api.put('/journeys/' + id, patch);
  },

  async remove(id) {
    return api.del('/journeys/' + id);
  },

  async activate(id) {
    return api.put('/journeys/' + id + '/activate');
  },

  async pause(id) {
    return api.put('/journeys/' + id + '/pause');
  },

  async stop(id) {
    return api.put('/journeys/' + id + '/stop');
  },

  async stats(id) {
    return api.get('/journeys/' + id + '/stats');
  },
};
